import { render, staticRenderFns } from "./action_buttons.vue?vue&type=template&id=2bf643ac"
import script from "./action_buttons.vue?vue&type=script&lang=js"
export * from "./action_buttons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports